
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserInterface } from '@/services/Users/Interfaces';
import RoleRepository from '../../../services/Roles';
import { RoleInterface } from '@/services/Roles/Interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateRoleForm from '@/services/Auth/forms/CreateRoleForm';

@Component({
  inject: [
    'rolesRepository',
  ],
})
export default class ChangeUsersRoleDialog extends Vue {
  private readonly rolesRepository!: RoleRepository;
  private roles!: RoleInterface[];
  private selectedRole: string = '';
  private form: WPXFormValue<CreateRoleForm> = new WPXFormValue(CreateRoleForm);

  @Prop() private readonly users!: UserInterface[];

  private visible: boolean = true;
  private loading: boolean = true;

  private created(): void {
    this.initialize();
  }

  private async initialize(): Promise<void> {
    this.roles = (await this.rolesRepository.getAllRoles()).filter((role) => role.name !== 'admin');
    this.loading = false;
  }

  private async changeRoles(): Promise<void> {
    try {
      await this.rolesRepository.changeUsersRole(
        this.users.map((user) => user.id),
        this.selectedRole,
      );
      this.$successDialog.show(`Users role has been updated.`);
      this.$emit('changed-role');
      this.destroyComponent();
    } catch (e) {
      this.$successDialog.show(e.response.data.message);
      this.destroyComponent();
    }
  }

  private destroyComponent(): void {
    this.$emit('close');
  }
}
